import { Text } from 'preact-i18n';
import DiscountBadge from './DiscountBadge';

const RoundSwitchItem = ({ label, name, onChange, value, selected, discount, redBadge }) => {
  return (
    <label className="round-switch-item">
      <input
        checked={selected === value}
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />
      <span className="switch-item">
        <Text id={`label.${label}`} />
        {discount && <DiscountBadge discount={discount} redBadge={redBadge} />}
      </span>
    </label>
  );
};

export default RoundSwitchItem;
